var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","flat":"","absolute":"","color":"transparent"}},[_c('v-toolbar-title',[_c('span',{staticClass:"title font-weight-regular"},[_vm._v("POI Tracker")])]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }